import React from 'react';
import { IconRender, InheritProps } from '../IconRender';

export function TwoContentIcon(props: InheritProps) {
  return (
    <IconRender
      {...props}
      childrenRender={(color: string) => (
        <>
        <rect x="1" y="1" width="48" height="78" rx="7" fill="#343434" stroke={color} strokeWidth="4"/>
        <path d="M45.9995 27.5C45.9995 26.6716 46.6711 26 47.4995 26H47.9995V54H47.4995C46.6711 54 45.9995 53.3284 45.9995 52.5V27.5Z" fill="#D9D9D9"/>
        <path d="M4.04729 52.4646C4.04841 53.293 3.37774 53.9656 2.54932 53.9668L2.03769 53.9676L1.99982 26.0032L2.51145 26.0024C3.33988 26.0012 4.01236 26.6718 4.01348 27.5002L4.04729 52.4646Z" fill="#D9D9D9"/>
        <rect x="5.99951" y="26" width="18" height="28" rx="1.5" fill="#D9D9D9"/>
        <rect x="25.9995" y="26" width="18" height="28" rx="1.5" fill="#D9D9D9"/>
        </>
      )}
    />
  );
}
